import { render, staticRenderFns } from "./TrafficMessageReplacementText.vue?vue&type=template&id=7a5dd040"
import script from "./TrafficMessageReplacementText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageReplacementText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports